import Vue from "vue";
import Router from "vue-router";
import { store } from "../store";

import HomePage from "../components/Home.vue";
import Login from "../components/authentication/Login";
import ChangePassword from "../components/account/ChangePassword";
import ResetPassword from "../components/account/ResetPassword";
import RequestNewPassword from "../components/account/RequestNewPassword";
import Profile from "../components/account/Profile";
import ClientCoachingProfilePage from "../components/client/ClientProfile";
import ManageSubscriptionPage from "../components/operations/ManageSubscription";
import ClientProfilePage from "../components/client/FullClientView";
import ClientsPage from "../components/client/Clients";
import ClientAssessmentsPage from "../components/client/blocks/progress/assessments/Assessments";
import LeadsDashboard from "../components/dashboard/Leads";
import Chats from "../components/chats/Chats";
import ChatListView from "@/components/chats/ChatListView";
import OnboardingDashboard from "../components/operations/Onboarding";
import HighPriorityOnboarding from "../components/operations/HighPriorityOnboarding";
import OnboardingSummary from "../components/operations/OnboardingSummary";
import OnboardingPage from "@/components/coaching/Onboarding";
import Admin from "../components/admin/Admin";
import BadgeAdmin from "../components/admin/badges/BadgeAdmin";
import MoveCoachClientsAdmin from "@/components/admin/MoveCoachClients";
import AssignUsersToAccountabilityGroup from "@/components/admin/AssignUsersToAccountabilityGroup";
import WhatsAppGroupsFreshPrograms from "@/components/admin/WhatsAppGroupsFreshPrograms";

import CoachAllocation from "@/components/admin/CoachAllocation";
import NoAccess from "../components/NoAccess.vue";
import PageNotFound from "../components/404.vue";
import CoachHistory from "../components/dashboard/CoachHistory";
import CompanyHistory from "../components/dashboard/CompanyHistory";
import BillingBase from "../components/billing/Base";
import BillingDashboard from "../components/billing/Dashboard";
import PaymentReporting from "../components/billing/PaymentReporting";
import SignupsReporting from "../components/billing/Signups";
import PrizeReport from "../components/billing/PrizeReport";
import CancellationsReporting from "../components/billing/Cancellations";
import CancellationRequestsReporting from "../components/billing/CancellationRequests";
import SalesReporting from "../components/billing/Sales";
import OnboardingLifeDashboard from "../components/operations/life/Onboarding";
import OnboardingClubDashboard from "../components/operations/club/Onboarding";
import PaymentsList from "../components/operations/billing/Payments";
import History from "../components/coaching/History";
import EngagementSummaryCoaching from "../components/reporting/EngagementSummaryCoaching";
import ComplianceSummary from "../components/reporting/ComplianceSummary";
import EngagementSummary from "../components/reporting/EngagementSummary";
import CorporateSummary from "../components/reporting/CorporateSummary";
import SurveyResults from "../components/reporting/SurveyResults";
import ProgramReport from "../components/reporting/ProgramReport";
import GroupReport from "../components/reporting/GroupReport";
import SurveyView from "../components/reporting/SurveyView";
import CapacityPlanning from "../components/reporting/CapacityPlanning";
import CorporateListing from "../components/reporting/CorporateListing";
import CorporateView from "../components/reporting/CorporateView";

import CoachingDashboard from "@/components/dashboard/CoachingDashboard";
import ClientDashboardBase from "@/components/dashboard/ClientDashboardBase";
import CoachingOnboardingSubscription from "@/components/dashboard/components/CoachingOnboardingSubscription";
import CoachingOneOnOneSubscription from "@/components/dashboard/components/CoachingOneOnOneSubscription";
import CoachingSecondarySubscription from "@/components/dashboard/components/CoachingSecondarySubscription";
import CoachingGradSubscription from "@/components/dashboard/components/CoachingGradSubscription";
import CoachingClubSubscription from "@/components/dashboard/components/CoachingClubSubscription";
import CoachingPackageSubscription from "@/components/dashboard/components/CoachingPackageSubscription";
import CoachingOffboardingSubscription from "@/components/dashboard/components/CoachingOffboardingSubscription";
import CoachingManageSecondarySubscription from "@/components/dashboard/components/CoachingManageSecondarySubscription";

import Post from "@/components/social/Post";
import UpcomingPayments from "@/components/billing/UpcomingPayments";

import TaskBase from "@/components/task/Base";
import TaskView from "@/components/task/TaskView";
import ClubSummary from "@/components/task/ClubSummary";
import SupportTaskListing from "@/components/task/Support";
import TaskListing from "@/components/task/TaskListing";

import CashFlowProjection from "@/components/billing/CashFlowProjection";
import FailedPayments from "@/components/billing/FailedPayments";
import BulkMessengerView from "@/components/chats/BulkMessengerView";
import BulkMessagesView from "@/components/chats/BulkMessagesView";

import ReportingBase from "@/components/reporting/Base";
import OperationsDashboard from "@/components/reporting/OperationsDashboard";
import CoachingReportingDashboard from "@/components/reporting/CoachingDashboard";
import TaskReporting from "@/components/reporting/Tasks";
import UserExport from "@/components/reporting/UserExport";
import DealDashboard from "@/components/deals/DealDashboard";
import DealView from "@/components/deals/DealView";
import DealReportingBase from "../components/reporting/deals/Base";
import DealCompanyReport from "../components/reporting/deals/DealCompanyReport";
import DealIndividualReport from "../components/reporting/deals/DealIndividualReport";
import TaskList from "@/components/task_v2/views/TaskList";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: HomePage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        guest: true,
      },
    },
    {
      path: "/account/reset-password",
      name: "ChangePassword",
      component: ChangePassword,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/tasks-dashboard",
      name: "TaskListingV2",
      component: TaskList,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/tasks/:userId",
      name: "TaskBase",
      component: TaskBase,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/task/:taskId",
      name: "TaskView",
      component: TaskView,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/tasks",
      name: "TaskListing",
      component: TaskListing,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/users/tasks",
      name: "ClubSummary",
      component: ClubSummary,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/support/tasks/:userId",
      name: "SupportTaskListing",
      component: SupportTaskListing,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reset-password/:token",
      name: "ResetPassword",
      component: ResetPassword,
      props: true,
      meta: {
        guest: true,
      },
    },
    {
      path: "/forgot-password/",
      name: "RequestNewPassword",
      component: RequestNewPassword,
      props: true,
    },
    {
      path: "/client-profile/:userId",
      name: "ClientProfilePage",
      component: ClientProfilePage,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/deals",
      name: "DealReportingBase",
      component: DealReportingBase,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "company",
          component: DealCompanyReport,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "individual",
          component: DealIndividualReport,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/reporting/billing",
      name: "BillingBase",
      component: BillingBase,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "dashboard",
          component: BillingDashboard,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "payment-issues",
          component: PaymentReporting,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "prize-report",
          component: PrizeReport,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "sign-ups",
          component: SignupsReporting,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "cancellations",
          component: CancellationsReporting,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "cancellation-requests",
          component: CancellationRequestsReporting,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "sales",
          component: SalesReporting,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "cashflow-projection",
          component: CashFlowProjection,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "failed-payments",
          component: FailedPayments,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/reporting/company",
      name: "ReportingBase",
      component: ReportingBase,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "operations",
          component: OperationsDashboard,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "coaching",
          component: CoachingReportingDashboard,
          props: true,
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/social/posts",
      name: "Post",
      component: Post,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dashboard/:coachId",
      name: "CoachingDashboard",
      component: CoachingDashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "clients",
          name: "ClientDashboardBase",
          component: ClientDashboardBase,
          props: true,
          meta: {
            requiresAuth: true,
          },
          children: [
            {
              path: "onboarding",
              component: CoachingOnboardingSubscription,
              props: true,
              name: "CoachingOnboardingSubscription",
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: "daily",
              component: CoachingOneOnOneSubscription,
              props: true,
              name: "CoachingOneOnOneSubscription",
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: "grad",
              component: CoachingGradSubscription,
              props: true,
              name: "CoachingGradSubscription",
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: "club",
              component: CoachingClubSubscription,
              props: true,
              name: "CoachingClubSubscription",
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: "package",
              component: CoachingPackageSubscription,
              props: true,
              name: "CoachingPackageSubscription",
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: "offboarding",
              component: CoachingOffboardingSubscription,
              props: true,
              name: "CoachingOffboardingSubscription",
              meta: {
                requiresAuth: true,
              },
            },
            {
              path: "client-sitting",
              component: CoachingSecondarySubscription,
              props: true,
              name: "CoachingSecondarySubscription",
              meta: {
                requiresAuth: true,
              },
            },
          ],
        },
        {
          path: "manage-sitting",
          component: CoachingManageSecondarySubscription,
          props: true,
          name: "CoachingManageSecondarySubscription",
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "/client-profile/:userId/manage/subscription/:subscriptionId",
      name: "ManageSubscription",
      component: ManageSubscriptionPage,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/coaching/clients/history",
      name: "History",
      component: History,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/operations/billing/payments",
      name: "PaymentsList",
      component: PaymentsList,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/operations/billing/upcoming-payments",
      name: "UpcomingPayments",
      component: UpcomingPayments,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/operations/onboarding/one-on-one",
      name: "OnboardingDashboard",
      component: OnboardingDashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/operations/onboarding/life",
      name: "LifeOnboarding",
      component: OnboardingLifeDashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/operations/onboarding/club",
      name: "ClubOnboarding",
      component: OnboardingClubDashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/operations/onboarding/priority",
      name: "HighPriorityOnboarding",
      component: HighPriorityOnboarding,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/onboarding/summary",
      name: "OnboardingSummary",
      component: OnboardingSummary,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/coaching/onboarding/:userId",
      name: "CoachingOnboarding",
      component: OnboardingPage,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/client-profile/:coachId/:userId",
      name: "CoachClientProfile",
      component: ClientCoachingProfilePage,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/clients",
      name: "Clients",
      component: ClientsPage,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/clients/:userId",
      name: "ClientPage",
      component: ClientProfilePage,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/client-profile/:coachId?/:userId/assessments",
      name: "CoachClientAssessments",
      component: ClientAssessmentsPage,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/leads-dashboard",
      name: "LeadsDashboard",
      component: LeadsDashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/compliance/summary",
      name: "ComplianceSummary",
      component: ComplianceSummary,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/corporate/summary",
      name: "CorporateSummary",
      component: CorporateSummary,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/engagement/coaching",
      name: "EngagementSummaryCoaching",
      component: EngagementSummaryCoaching,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/engagement/summary",
      name: "EngagementSummary",
      component: EngagementSummary,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/corporate",
      name: "CorporateListing",
      component: CorporateListing,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/corporate/:corporateChallengeId",
      name: "CorporateView",
      component: CorporateView,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/admin/",
      name: "Admin",
      component: Admin,
      props: true,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: "badge",
          component: BadgeAdmin,
          children: [
            {
              path: "coach",
              component: Admin,
            },
            {
              path: "challenge",
              component: Admin,
            },
            {
              path: "consistency",
              component: Admin,
            },
            {
              path: "event",
              component: Admin,
            },
            {
              path: "custom",
              component: Admin,
            },
          ],
        },
        {
          path: "move-coach-clients",
          component: MoveCoachClientsAdmin,
        },
        {
          path: "coach-allocation",
          component: CoachAllocation,
        },
        {
          path: "assign-accountability-groups",
          component: AssignUsersToAccountabilityGroup,
        },
        {
          path: "whats-app-groups-fresh-programs",
          component: WhatsAppGroupsFreshPrograms,
        },
      ],
    },
    {
      path: "/no-access",
      name: "NoAccess",
      component: NoAccess,
      props: false,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/account/profile",
      name: "Profile",
      component: Profile,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/chats",
      name: "ChatListView",
      component: ChatListView,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/chats-old",
      name: "Chats",
      component: Chats,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/chats/bulk-messenger/:bulkMessageId?",
      name: "BulkMessengerView",
      component: BulkMessengerView,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/chats/bulk-messages/",
      name: "BulkMessagesView",
      component: BulkMessagesView,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dashboard/history/:coachId",
      name: "CoachHistory",
      component: CoachHistory,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/company-history",
      name: "CompanyHistory",
      component: CompanyHistory,
      props: false,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/survey-results",
      name: "SurveyResults",
      component: SurveyResults,
      props: false,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/programs",
      name: "ProgramReport",
      component: ProgramReport,
      props: false,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/groups",
      name: "GroupReport",
      component: GroupReport,
      props: false,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/capacity-planning",
      name: "CapacityPlanning",
      component: CapacityPlanning,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/survey-results/:subscriptionSurveyId",
      name: "SurveyView",
      component: SurveyView,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/tasks",
      name: "TaskReporting",
      component: TaskReporting,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/reporting/export",
      name: "UserExport",
      component: UserExport,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/accountability/assign",
      name: "AssignUsersToAccountabilityGroupView",
      component: AssignUsersToAccountabilityGroup,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/deals",
      name: "DealDashboard",
      component: DealDashboard,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/deals/:id",
      name: "DealView",
      component: DealView,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    // PageNotFound should always be last
    {
      path: "*",
      name: "PageNotFound",
      component: PageNotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Handle redirecting to /login if not logged in
    if (store.getters.isLoggedIn) {
      next();
    } else {
      sessionStorage.setItem("redirectPath", to.path);
      next({
        path: "/login",
        query: { error: 1 },
      });
    }
  }
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isLoggedIn) {
      var path = sessionStorage.getItem("redirectPath") || "";
      if (path != "") {
        sessionStorage.removeItem("redirectPath");
        next(path);
      } else {
        next("/");
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

router.onError((error) => {
  if (/loading.* chunk .* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
